import { Operation } from '@apollo/client';
import { type GraphQLFormattedError } from 'graphql';
import toast from 'react-hot-toast';

import i18n from 'src/i18n';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const handleErrors = (errors: readonly GraphQLFormattedError[], operation: Operation): boolean => {
  if (errors.length > 0) {
    // Const context = operation.getContext();
    const message: string = typeof errors[0]?.message === 'string' ? errors[0].message : 'Unknown error.';
    switch (message) {
      case 'Invalid credentials':
        toast.error(i18n.t('translation:messages.error.invalid-credentials'));
        return true;

      case 'Email already exists.':
        toast.error(i18n.t('translation:messages.error.email-already-exist'));
        return true;

      case 'Invalid password reset token':
        toast.error(i18n.t('translation:messages.error.invalid-reset-token'));
        return true;

      case "Old and new password can't be the same":
        toast.error(i18n.t('translation:messages.error.password-update.incorrect-new'));
        return true;

      case 'Valuation date is required':
        break;

      default:
        toast.error(i18n.t('translation:messages.error.unknown-error'));
        // eslint-disable-next-line no-console
        console.error('Unknown error:', errors);
        break;
    }

    return false;
  }
  return false;
};
